import IconButton from '@material-ui/core/IconButton';
import { default as MuiMenu } from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import { useIsUserLoggedIn } from 'components/user/UserProvider';
import React from 'react';
import { Link } from 'react-router-dom';
import LoginButton from '../LoginButton';
import styles from './MobileMenu.module.css';

const MobileMenu: React.SFC<{}> = () => {
  const isLoggedIn = useIsUserLoggedIn();

  const [anchorEl, setAnchorEl] = React.useState(null);

  function handleClick(event: any) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }
  return (
    <div>
      <IconButton
        aria-controls="main-menu"
        aria-haspopup="true"
        onClick={handleClick}
        aria-label="Navigation Menu"
      >
        <MenuIcon />
      </IconButton>
      <MuiMenu
        id="main-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <LoginButton ButtonProps={{ className: styles.menuItem }} />
        </MenuItem>
        {!isLoggedIn && (
          <MenuItem onClick={handleClose}>
            <Link to="/signup" className={styles.menuItem}>
              Signup
            </Link>
          </MenuItem>
        )}
        <MenuItem onClick={handleClose}>
          <Link to="/" className={styles.menuItem}>
            Browse Lessons
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link to="/submit" className={styles.menuItem}>
            Submit Lesson
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link to="/about" className={styles.menuItem}>
            About Us
          </Link>
        </MenuItem>
      </MuiMenu>
    </div>
  );
};

export default MobileMenu;
